import assetArchivedProjections from './projection/asset-archived.projection';
import assetCreatedProjections from './projection/asset-created.projection';
import assetDeletedProjections from './projection/asset-deleted.projection';
import assetUnarchivedProjections from './projection/asset-unarchived.projection';
import assetUpdatedProjections from './projection/asset-updated.projection';
import assetUpdatedFromInspectionProjections from './projection/asset-updated-from-inspection.projection';
import assetPurgedProjections from './projection/asset-purged.projection';
import fieldSyncAssetUpdatedProjections from './projection/field-sync-asset-updated.projection';
import photosLinkedToAssetProjections from './projection/photos-linked-to-asset.projection';
import photosUnlinkedFromAssetProjections from './projection/photos-unlinked-from-asset.projection';
import legacyPhotosLinkedToAssetProjections from './projection/legacy-photos-linked-to-asset.projection';
import legacyPhotosLinkedToAssetV2Projections from './projection/legacy-photos-linked-to-asset-v2.projection';
import legacyPhotosUnlinkedFromAssetProjections from './projection/legacy-photos-unlinked-from-asset.projection';
import legacyPhotosUnlinkedFromAssetV2Projections from './projection/legacy-photos-unlinked-from-asset-v2.projection';
const projections = {
    ...assetCreatedProjections,
    ...assetUpdatedProjections,
    ...assetUpdatedFromInspectionProjections,
    ...assetDeletedProjections,
    ...assetArchivedProjections,
    ...assetUnarchivedProjections,
    ...assetPurgedProjections,
    ...fieldSyncAssetUpdatedProjections,
    ...photosLinkedToAssetProjections,
    ...photosUnlinkedFromAssetProjections,
    ...legacyPhotosLinkedToAssetProjections,
    ...legacyPhotosLinkedToAssetV2Projections,
    ...legacyPhotosUnlinkedFromAssetProjections,
    ...legacyPhotosUnlinkedFromAssetV2Projections,
};
export default projections;
//# sourceMappingURL=projections-index.js.map